const lang = {}
lang.home = 'Home'
lang.About = 'About'
lang.Contact = 'Contact'
lang.Demo = 'Demo'
lang.English = 'English'
lang.zh = '中文简体'
export default lang
